import styled from 'styled-components'

import { LinkButton } from '@sketch/components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  /* Override IndexLayout SubTitle styles */
  && {
    margin: 24px auto 24px auto;

    /* Override Button sibling styles */
    button + button,
    button + a,
    a + a {
      margin-left: 0px;
    }
  }
`

export const ButtonContainer = styled.div<{ $isSSOEnabled: boolean }>`
  display: grid;
  grid-template-areas:
    'google'
    'apple'
    'sso';

  width: 100%;
  gap: 16px;

  ${({ $isSSOEnabled }) =>
    !$isSSOEnabled &&
    `
    grid-template-areas:
      'google'
      'apple';
  `}
`

export const StyledLinkButton = styled(LinkButton)`
  grid-area: sso;

  color: ${({ theme }) => theme.colors.foreground.secondary.B};

  :hover {
    color: ${({ theme }) => theme.colors.foreground.secondary.B};
  }

  @media (prefers-color-scheme: dark) {
    box-shadow: none;
    border: none;
  }
`

export const Divider = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-size: ${({ theme }) => theme.fontSizes.E};
  text-align: center;
  margin-top: 8px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.border.A};
    transform: translateY(1px);
  }

  &::before {
    margin-right: 8px;
  }

  &::after {
    margin-left: 8px;
  }
`
